export const formatNumber = (num, locale = 'en-US') => {
    return new Intl.NumberFormat(locale, {
        notation: "compact",
        maximumFractionDigits: 2, // Adjust for desired precision
    }).format(num);
};